// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"696416ce","749":"6534705f","895":"30e940b6","903":"8861fcef"}[chunkId] + ".chunk.css";
};